import React from "react";
import { useParams } from "react-router-dom";
import { jobs } from "./JobList"; // 👈 IMPORTANT

export default function CareerDetails() {
  const { id } = useParams();
  const job = jobs.find((j) => j.id === Number(id));

  if (!job) {
    return <h2 className="text-center mt-20 font-semibold font-SpaceGrotesk text-primaryColor">Job Not Found</h2>;
  }

  return (
    <div className="bg-white py-10">
      <div className="w-full max-w-5xl mx-auto bg-white rounded-2xl shadow-md p-8">

        <div className="flex justify-between items-center mb-8">
          <h1 className="text-2xl font-bold text-gray-800">
            {String(job.id).padStart(2, "0")}. {job.title}
          </h1>
          <button className="px-4 py-2 bg-blue-900 text-white rounded-lg hover:bg-blue-800">
            Apply Now
          </button>
        </div>

        <div className="border rounded-xl p-6 space-y-3 mb-8 bg-gray-50">
          <p><strong>Job Title:</strong> {job.title}</p>
          <p><strong>Job Location:</strong> {job.location}</p>
          <p><strong>Date:</strong> {job.date}</p>
        </div>

        <h2 className="text-xl font-semibold font-SpaceGrotesk mb-3 text-gray-800">
          Roles & Responsibilities
        </h2>

        <ul className="list-disc pl-6 space-y-2 text-gray-700">
          <li>Collaborate closely with the hiring manager...</li>
          <li>Source and attract top-tier professionals...</li>
        </ul>

        <div className="mt-10 text-center">
          <button className="px-6 py-3 bg-blue-900 text-white rounded-lg hover:bg-blue-800">
            Apply Now
          </button>
        </div>
      </div>
    </div>
  );
}
